var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFooterTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.29858 10.7772C3.69221 11.1646 4.32536 11.1595 4.71274 10.7659L7 8.4417V14.9999C7 15.5522 7.44772 15.9999 8 15.9999C8.55228 15.9999 9 15.5522 9 14.9999V8.4417L11.2873 10.7659C11.6746 11.1595 12.3078 11.1646 12.7014 10.7772C13.0951 10.3898 13.1001 9.75665 12.7127 9.36301L8 4.57422L3.28726 9.36301C2.89987 9.75665 2.90494 10.3898 3.29858 10.7772Z",
    fill: "#666E7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2C0 1.44772 0.447715 1 1 1H15C15.5523 1 16 1.44772 16 2C16 2.55228 15.5523 3 15 3H1C0.447715 3 0 2.55228 0 2Z",
    fill: "#666E7A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTop);
export default __webpack_public_path__ + "static/media/footer_top.b3dfa6d2561c5c42b43c63407e74e2fe.svg";
export { ForwardRef as ReactComponent };